import { Routes } from '@angular/router';
import { getPathModule, getPathComponent, getRedirects } from './shared/functions';

import { MainComponent } from './shared/layout/main.component';

import { HomeComponent } from './features/home/home/home.component';
import { RankingHomeComponent } from './features/ranking/ranking-home/ranking-home.component';
import { ContactHomeComponent } from './features/contact/contact-home/contact-home.component';
import { DeadPageComponent } from './features/obituaries/dead-page/dead-page.component';
import { ListsModule } from './features/lists/lists.module';
import { Error404Component } from './shared/error/error404.component';

const devRoute = getPathModule(
	['dev'],
	() => import("./features/dev/dev.module").then(m => m.DevModule),
);

const redirects = getRedirects({
	"Contato/Sobre": "bolao/sobre",
	"sobre": "bolao/sobre",
	"ver-lista/:hash": "listas/ver-lista/:hash",
});

export const routes: Routes = [
	{
		path: '',
		component: MainComponent,
		children: [
			{
				path: '',
				component: HomeComponent,
			},
			...getPathComponent(
				["ranking", "Bolao/Ranking"],
				RankingHomeComponent,
			),
			...devRoute,
			...getPathModule(
				["listas"],
				() => import("./features/lists/lists.module").then(m => ListsModule),
			),
			...getPathModule(
				["obituario", "Presuntos"],
				() => import("./features/obituaries/obituaries.module").then(m => m.ObituariesModule),
			),
			...getPathComponent(
				["presuntos/:hash", "obituario/:hash", "Presuntos/View/:hash"],
				DeadPageComponent,
			),
			...getPathModule(
				["regulamento", "bolao", "Bolao/Regulamento"],
				() => import("./features/about/about.module").then(m => m.AboutModule),
			),
			...getPathComponent(
				["contato", "bolao/contato"],
				ContactHomeComponent,
			),
			...getPathModule(
				["retrospectiva"],
				() => import("./features/retrospectives/retrospectives.module").then(m => m.RetrospectivesModule),
			),
			...redirects,
		],
	},
	{ path: '**', component: Error404Component }
];
